import Label from "Components/Common/components/Label";
import React, { useEffect, useState } from "react";
import { TCFConstraintsWithoutValues, TCFValueConstriant } from "../types";
import ViewMoreButton from "Components/Common/components/ViewMoreButton";
import CustomSearchBar from "Components/GMS/Products/components/CustomSearchBar";
import { CF_ACTIVATE_MESSAGE } from "../AttributeConstants";

type EditCFProps = {
    cfDetails: TCFConstraintsWithoutValues | null,
    setCfDetails: React.Dispatch<React.SetStateAction<TCFConstraintsWithoutValues|null>>,
    attributeValuesCount: number,
    fetchCfConstraints: (search?: string, skip?: number, reset?: boolean) => Promise<void>,
    valueCfConstraints: TCFValueConstriant[]
    setValueCfConstraints: React.Dispatch<React.SetStateAction<TCFValueConstriant[]>>
    search?: string
    setSearch: React.Dispatch<React.SetStateAction<string|undefined>>
    hasClickedCFToggle: boolean
    setHasClickedCFToggle: React.Dispatch<React.SetStateAction<boolean>>
}

export default function EditCF({ 
    cfDetails, 
    setCfDetails,
    attributeValuesCount,
    fetchCfConstraints,
    valueCfConstraints,
    setValueCfConstraints,
    search,
    setSearch,
    hasClickedCFToggle,
    setHasClickedCFToggle
}: EditCFProps) {
    const VALUE = "value";
    const DISPLAY_VALUE = "displayValue";
    const IMAGE = "image";
  
    const [cfProp, setCfProp] = useState(cfDetails && cfDetails.cf_properties);
  
    useEffect(() => {
      cfDetails && setCfProp(cfDetails?.cf_properties);
    }, [cfDetails]);
  
    function getBool(val: string|boolean) {
      return !!JSON.parse(String(val).toLowerCase());
    }
  
    useEffect(() => {
      if (cfDetails?.cf_properties) {
        if (cfProp?.displaySearch === null || undefined) {
          setCfProp((prevState) => ({
            ...prevState,
            displaySearch: false,
          }));
        }
        if (cfProp?.valuesPerRow === null || undefined) {
          setCfProp((prevState) => ({
            ...prevState,
            valuesPerRow: 1,
          }));
        }
        if (cfProp?.maxHeight === null || undefined) {
          setCfProp((prevState) => ({
            ...prevState,
            maxHeight: "Not Set",
          }));
        }
        if (cfProp?.DisplayType === null || undefined) {
          setCfProp((prevState) => ({
            ...prevState,
            DisplayType: "value",
          }));
        }
      }
      if (cfProp) {
        setCfDetails((prev) => ({
          ...(prev as TCFConstraintsWithoutValues),
          cf_properties: cfProp,
        }));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cfProp]);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>, value: string|boolean|number) => {
      let field = e.target.name;
      setCfProp((prevState) => ({
        ...prevState,
        [field]: value,
      }));
    };
    const handleChecked = (e: React.ChangeEvent<HTMLInputElement>, value: string|boolean, isAbsEnable?: boolean) => {
      let field = e.target.name;
      if(!hasClickedCFToggle) setHasClickedCFToggle(true)
      setCfDetails((prevState) => {
				const nextState = {
						...(prevState as TCFConstraintsWithoutValues),
						[field]: value,
				}

				if(isAbsEnable) nextState['cf_enable_changed'] = true

				return nextState
			});
    };
  
    useEffect(() => {
      const isAnyCfShowTrue = valueCfConstraints.some(
        (singleValue) => singleValue.cf_show
      );
      
      if (cfDetails?.cf_enabled) {
        if (!isAnyCfShowTrue) {
          setValueCfConstraints((prev) => {
              const updatedValueConstraints = [...prev].map(
                (singleValue) => {
                  return { ...singleValue, cf_show: true };
                }
            );
            return updatedValueConstraints
          });
        }
      } else {
        if (isAnyCfShowTrue) {
          setValueCfConstraints((prev) => {
              const updatedValueConstraints = [...prev].map(
                (singleValue) => {
                  return { ...singleValue, cf_show: false };
                }
            );
            return updatedValueConstraints
          });
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cfDetails?.cf_enabled]);
  
    function handleValue(e: React.ChangeEvent<HTMLInputElement>, value: boolean|string, index: number) {
      let arr = [...valueCfConstraints];
      let obj = { ...arr[index] };
      obj = { ...obj, [e.target.name]: value, changed: true };
      arr.splice(index, 1, obj);
      setValueCfConstraints(arr)
    }  
    
    return (
      <>
        {cfProp && (
          <>
            <div className="form-check form-switch">
              <input
                className="form-check-input shadow-none"
                type="checkbox"
                name="cf_enabled"
                id="flexSwitchCheckChecked"
                onChange={(e) => handleChecked(e, !cfDetails?.cf_enabled, true)}
                checked={getBool(cfDetails?.cf_enabled ?? false)}
                value={`${cfDetails?.cf_enabled ?? true}`}
              />
              <Label
                message={CF_ACTIVATE_MESSAGE}
                fontSize={"0.8"}
                htmlFor="flexSwitchCheckChecked"
              />
            </div>
            <div className="form-check form-switch mr-2">
              <input
                className="form-check-input shadow-none"
                type="checkbox"
                disabled={!cfDetails?.cf_enabled}
                name="displaySearch"
                id="name"
                checked={getBool(cfProp?.displaySearch ?? false)}
                value={`${cfDetails?.displaySearch}`}
                onChange={(e) => handleChange(e, !getBool(cfProp?.displaySearch ?? false))}
              />
              <Label message="Display Search?" fontSize={"0.8"} htmlFor="name" />
              {/* <label className="form-check-label" htmlFor="name">
                Display Search?
              </label> */}
            </div>
  
            <div className="mt-3 mb-3">
              <Label message="Display Name" fontSize={"0.8"} htmlFor="name" />
              {/* <label htmlFor="floatingInput" className="mb-2">
                Display Name
              </label> */}
              <input
                type="text"
                style={{ fontWeight: "600", fontSize: ".8rem" }}
                className="form-control shadow-none"
                id="floatingInput"
                name="displayName"
                disabled={!cfDetails?.cf_enabled}
                value={cfProp?.displayName}
                placeholder="name"
                onChange={(e) => handleChange(e, e.target.value)}
              />
            </div>
            <div className="d-flex justify-content-between">
              <div className="w-25">
                <Label message="Display Type" fontSize={"0.8"} />
                {/* <label htmlFor="floatingInput">Display Type</label> */}
                <select
                  className="form-select form-select-sm mt-2 shadow-none"
                  aria-label=".form-select-sm example"
                  disabled={!cfDetails?.cf_enabled}
                  name="DisplayType"
                  style={{ fontSize: ".8rem", fontWeight: "600" }}
                  onChange={(e) => handleChange(e, e.target.value)}
                  value={cfProp?.DisplayType}
                >
                  <option value={VALUE}>No</option>
                  <option value={DISPLAY_VALUE}>Yes, Text</option>
                  <option value={IMAGE}>Yes, Images</option>
                </select>
              </div>
  
              <div className="w-25">
                <Label message="Values Per Row" fontSize={"0.8"} />
                {/* <label htmlFor="floatingInput">Values Per Row</label> */}
                <select
                  className="form-select form-select-sm mt-2 shadow-none"
                  aria-label=".form-select-sm example"
                  name="valuesPerRow"
                  disabled={!cfDetails?.cf_enabled}
                  style={{ fontSize: ".8rem", fontWeight: "600" }}
                  onChange={(e) => handleChange(e, parseInt(e.target.value))}
                  value={cfProp?.valuesPerRow}
                >
                  <option value={1}>One Value</option>
                  <option value={2}>Two Values</option>
                  <option value={3}>Three Values</option>
                  <option value={4}>Four Values</option>
                  <option value={5}>Five Values</option>
                </select>
              </div>
              <div className="w-25">
                {/* <label htmlFor="floatingInput"> Max Height</label> */}
                <Label message="Max Height" fontSize={"0.8"} />
                <select
                  className="form-select form-select-sm mt-2 shadow-none"
                  aria-label=".form-select-sm example"
                  name="maxHeight"
                  disabled={!cfDetails?.cf_enabled}
                  style={{ fontSize: ".8rem", fontWeight: "600" }}
                  onChange={(e) => handleChange(e, e.target.value)}
                  value={cfProp?.maxHeight}
                >
                  <option value="Not Set">Not Set</option>
                  <option value="Small">Small</option>
                  <option value="Medium">Medium</option>
                  <option value="Large">Large</option>
                </select>
              </div>
            </div>

            <div className="tw-pt-2">
                <div className="tw-w-60 ">
                    <CustomSearchBar 
                        placeholder="Search Attribute Values"
                        handleSearchChange = {setSearch}
                        value={search}
                    />
                </div>
            </div>
  
            {valueCfConstraints &&
              valueCfConstraints.length > 0 && (
                <>
                  <table className="table table-sm table-borderless mt-4">
                    <thead>
                      <tr className="mb-5">
                        <th scope="col" style={{ fontSize: ".8rem" }}>
                          Display
                        </th>
                        <th scope="col" style={{ fontSize: ".8rem" }}>
                          Value
                        </th>
                        <th scope="col" style={{ fontSize: ".8rem" }}>
                          CF Display Value
                        </th>
                      </tr>
                    </thead>
                    <tbody className="align-middle">
                      {valueCfConstraints?.map((singleValue, index) => {
                        return (
                          <tr key={index}>
                            <td style={{ width: "10%" }}>
                              <div className="form-check form-switch mb-3 mr-2 align-middle mt-2">
                                <input
                                  className="form-check-input shadow-none"
                                  type="checkbox"
                                  name="cf_show"
                                  disabled={!cfDetails?.cf_enabled}
                                  id={`${index}`}
                                  checked={getBool(singleValue.cf_show)}
                                  value={`${getBool(singleValue.cf_show)}`}
                                  onChange={(e) =>
                                    handleValue(
                                      e,
                                      !getBool(singleValue.cf_show),
                                      index
                                    )
                                  }
                                />
                              </div>
                            </td>
  
                            <td style={{ fontSize: ".8rem", fontWeight: "600" }}>
                              {singleValue.value}
                            </td>
  
                            <td className="mb-2">
                              <input
                                type="text"
                                className="form-control shadow-none"
                                style={{
                                  padding: "1",
                                  fontSize: ".875rem",
                                  fontWeight: "500",
                                }}
                                name="cf_display_value"
                                disabled={!cfDetails?.cf_enabled}
                                value={singleValue.cf_display_value}
                                placeholder="CF Display value"
                                onChange={(e) =>
                                  handleValue(e, e.target.value, index)
                                }
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  <ViewMoreButton
                    condition = {valueCfConstraints.length < attributeValuesCount}
                    state = {valueCfConstraints.length >= attributeValuesCount}
                    handleClick = {() => fetchCfConstraints(search, valueCfConstraints.length)}
                    />
                </>
              )}
          </>
        )}
      </>
    );
  }
  